import { CustomLink } from "@/components/Global/CustomLink";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { useRouter } from "next/router";
import React from "react";
import { makePageLink, getTypeLabel } from "../SearchTab/utils";
import { SearchResultItemType } from "../useSearch";
import styles from "./ResultItem.module.scss";
import { Icon } from "@/components/Global/Icon/Icon";
interface ResultItemProps {
  result: SearchResultItemType;
  cardType?: "kleine_tip_topf" | "tip_topf";
  index?: number;
}

export const ResultItem: React.FC<ResultItemProps> = ({
  result,
  cardType = "kleine_tip_topf",
  //   cardType = "large",
  // index = 1,
}) => {
  const { locale } = useRouter();
  const { getIcon } = useGlobalContext();

  let resultTypeIcon: string;
  let dietTypeIcon: string = "";
  let resultLinkUrl = "/";

  switch (result.value_type) {
    case "Rezept":
      resultTypeIcon = getIcon("recipesNavi");
      resultLinkUrl = `${locale === "de" ? "/rezepte" : "/recettes"}/${result.value_id}`;
      break;
    case "Zutat":
      cardType = "tip_topf";
      resultTypeIcon = getIcon("ingredient");
      resultLinkUrl = `/${locale === "de" ? "rezepte" : "recettes"}?filterSortType=sort_aktuell&filterZutat=${result.value_id}`;
      break;
    case "Kategorie":
      resultTypeIcon = getIcon("tippsTricksNavi");
      resultLinkUrl = `/${locale === "de" ? "rezepte" : "recettes"}?filterSortType=sort_aktuell&filterKategorie=${result.value_id}`;
      break;
    case "Zubereitungsart":
      resultTypeIcon = getIcon("methodIcon");
      resultLinkUrl = `/${locale === "de" ? "rezepte" : "recettes"}?filterSortType=sort_aktuell&filterGarmethode=${result.value_id}`;
      break;
    case "Saison":
      resultTypeIcon = getIcon("seasonIcon");
      resultLinkUrl = `/${locale === "de" ? "rezepte" : "recettes"}?filterSortType=sort_aktuell&filterSaisons=${result.value_id}`;
      break;
    case "Beitrag":
      resultTypeIcon = getIcon("article");
      resultLinkUrl = makePageLink(result);
      break;
    case "no results":
      resultTypeIcon = getIcon("close");
      break;
    default:
      resultTypeIcon = getIcon("article");
      break;
  }

  if (result.value_ernaehrungsform?.includes(1)) {
    dietTypeIcon = getIcon("vegan");
  } else if (result.value_ernaehrungsform?.includes(2)) {
    dietTypeIcon = getIcon("vegetarisch");
  }
  return (
    <CustomLink
      href={`${cardType === "tip_topf" ? process.env.SEARCH_EXTERNAL_URL : ""}${resultLinkUrl}`}
      target={cardType === "tip_topf" ? "_blank" : "_self"}
      className={`result-item ${styles["result-item"]}`}
      disablePrefetch={cardType !== "kleine_tip_topf"}
    >
      {/* {index} */}
      {resultTypeIcon && <Icon src={resultTypeIcon} />}
      <div className="text">
        <span
          className={styles["result-name"]}
          dangerouslySetInnerHTML={{ __html: result.value_titel }}
        />

        <span className={styles["result-sub"]}>
          {getTypeLabel(result.value_type)}
        </span>
      </div>

      <div className={styles["type-icon"]}>
        {cardType === "tip_topf" ? (
          <Icon
            width={18}
            height={18}
            src={getIcon("externalLink")}
            ariaHidden
          />
        ) : (
          <Icon src={dietTypeIcon} ariaHidden />
        )}
      </div>
    </CustomLink>
  );
};

export const NoResult = () => {
  const { getLabel, getIcon } = useGlobalContext();
  return (
    <div
      className={`result-item ${styles["result-item"]} ${styles["no-result"]}`}
    >
      <Icon src={getIcon("searchNoResults")} />
      <div className="text">
        <span
          className={styles["result-name"]}
          dangerouslySetInnerHTML={{
            __html: getLabel(
              "search_no_results",
              "Deine Suche ergab keine Treffer.",
            ),
          }}
        />
      </div>
    </div>
  );
};
